export default "__VITE_ASSET__11ff86f3__"